// extracted by css-extract-rspack-plugin
export default {"Box":"route-title-module__Box__Ivd__hE","Octicon":"route-title-module__Octicon__IyiGRYl","Heading":"route-title-module__Heading__FCmGnDf"};